import React from 'react';

function Portfolio() {
  return (
    <section className="work-metro section-padding pt-40 sub-bg">
      <div className="container-xl">
        <div className="row xxlg-marg justify-content-between">
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/1.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Aevoe</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/2.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Digital Design</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/3.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Nice guy</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Photography</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/4.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Digital Design</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/5.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Digital Design</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/6.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/project4">Digital Design</a>
                </h5>
                <p className="ml-auto">
                  <a href="/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/7.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Digital Design</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-6">
            <div className="item mt-140">
              <div className="img">
                <img src="/dark/assets/imgs/works/stand/8.jpg" alt="" />
              </div>
              <div className="cont d-flex align-items-center mt-20">
                <h5 className="fz-22">
                  <a href="/dark/project4">Digital Design</a>
                </h5>
                <p className="ml-auto">
                  <a href="/dark/portfolio-metro">Branding</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
